import styled, { css } from 'styled-components';

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  margin-bottom: 10px;
`;

export const StatusWrapper = styled.div`
  position: relative;
  cursor: pointer;
`;

export const StatusSelect = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  min-width: 180px;
  width: 100%;

  > span {
    display: inline-flex;
    cursor: pointer;
  }
`;

export const Status = styled.div`
  display: flex;
  align-items: center;
  gap: 13px;
  margin-left: 4px;
`;

export const StatusColor = styled.div`
  height: 6px;
  width: 6px;
  border-radius: 50%;
  background-color: #ff9900;

  &[data-status='open'] {
    background-color: #1371fe;
  }
  &[data-status='closed'] {
    background-color: #c1c4d6;
  }
  &[data-status='resolved'] {
    background-color: #52bd94;
  }
`;

export const StatusName = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #474d66;
`;

export const Menu = styled.ul`
  margin: 0;
  padding: 8px 6px;
  background: #ffffff;
  box-shadow: 0px 6px 10px rgba(33, 39, 73, 0.12);
  border-radius: 8px;
  position: absolute;
  z-index: 1;
  top: calc(100% + 7px);
  min-width: 180px;
  width: 100%;

  hr {
    border: 0.5px solid #e6e8f0;
    margin-bottom: 8px;
  }
`;

type TChatStatus = {
  inactive?: boolean;
};

export const MenuItem = styled.li<TChatStatus>`
  font-family: 'Poppins' sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #474d66;
  list-style: none;
  padding: 6px 10px;

  :not(:last-child) {
    margin-bottom: 6px;
  }

  ${props => {
    if (props.inactive) {
      return css`
        color: #8f95b2;
      `;
    }
    return css`
      :hover {
        background: #f5f7fb;
        border-radius: 4px;
      }
    `;
  }}
`;

export const RequestDetailsLink = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #1371fe;
  text-decoration: none;
  cursor: pointer;
`;
